export const TabsData = [
    { nombre: "Datos personales", carpeta: "Registracion", componente: "Paso1", params: { key: 0 } },
    { nombre: "Obra social", carpeta: "Registracion", componente: "Paso2", params: { key: 1 } },
  ];
  